import Headroom from 'headroom.js';
import { Component } from 'js-component-framework';
import Throttle from '../../utilities/Throttle';
import SmoothScroll from '../../utilities/SmoothScroll';

/**
 * Component for instantiating Article Toolbar
 */
export default class ArticleToolbar extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Init sticky Nav
    this.headroom = new Headroom(
      this.element,
      this.options.headroom
    );
    this.headroom.init();

    // Throttle scroll event for progress bar
    this.progressBarThrottle = new Throttle(
      this.runProgressBar.bind(this),
      'scroll',
      document,
      50
    );

    // Logo link smoothly scrolls user back to top
    this.setSmoothScroll = new SmoothScroll('.article-toolbar__logo a');
    this.setSmoothScroll.init();
  }

  /**
   * Determine y-position in window scroll and display in percentage bar
   * @see https://blog.andyjiang.com/reading-position-horizontal-progress-bar
   */
  runProgressBar() {
    const body = document.body;
    const html = document.documentElement;
    const winInnerHeight = window.innerHeight;
    const winYPosition = (window.pageYOffset !== undefined) ?
      window.pageYOffset : (document.documentElement ||
      document.body.parentNode || document.body).scrollTop;
    const winMaxHeight = Math.max(body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight);
    // Calculate y-position percentage
    const position = (winYPosition / (winMaxHeight - winInnerHeight)) * 100;

    this.children.progressBar.setAttribute('style',
      `width:${position}%`);
  }
}



// WEBPACK FOOTER //
// ./client/js/components/Header/ArticleToolbar.js